import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { IPlaybooksItemDTO } from '../../../dto/playbooks-listening.dto';

@Component({
  selector: 'app-playbook-usage',
  standalone: true,
  imports: [],
  templateUrl: './playbook-usage.component.html',
  styleUrl: './playbook-usage.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PlaybookUsageComponent {
      @Input() dataItem: IPlaybooksItemDTO;
      @Input() columnOptions: ITableColumn;
}
